var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11242 13.5888C6.11242 13.5888 2.26758 10.3481 2.26758 7.08788C2.26758 5.93844 2.54205 4.65018 3.3661 3.8374C4.19016 3.02462 5.49629 2.75391 6.66168 2.75391C7.82707 2.75391 8.58394 3.02462 9.408 3.8374C10.2321 4.65018 11.0558 5.93844 11.0558 7.08788C11.0558 10.3481 6.66168 13.5888 6.66168 13.5888C6.43978 13.7904 6.33597 13.7882 6.11242 13.5888ZM6.66168 8.71312C6.91414 8.71312 6.97771 8.8084 7.21095 8.71312C7.44419 8.61783 7.5817 8.34744 7.76021 8.17137C7.93872 7.9953 8.21286 7.85967 8.30947 7.62962C8.40608 7.39958 8.30947 7.33688 8.30947 7.08788C8.30947 6.83888 8.40608 6.23443 8.30947 6.00438C8.21286 5.77434 7.93872 5.63871 7.76021 5.46264C7.5817 5.28657 7.44419 5.01618 7.21095 4.92089C6.97771 4.8256 6.91414 4.92089 6.66168 4.92089C6.15183 4.92089 5.37442 5.10705 5.01389 5.46264C4.65337 5.81823 4.46463 6.585 4.46463 7.08788C4.46463 7.59076 4.65337 7.81578 5.01389 8.17137C5.37442 8.52696 6.15183 8.71312 6.66168 8.71312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.26e2478f5db2dee916de663987a1b02d.svg";
export { ForwardRef as ReactComponent };